export default __webpack_public_path__ + "static/media/outbath2.9d738223.png";